import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';

@Component({
  selector: 'app-youtube-dialog',
  templateUrl: './youtube-dialog.component.html',
  styleUrls: ['./youtube-dialog.component.scss']
})
export class YoutubeDialogComponent implements OnInit {
  videoUrl: string;
  iframeHeight: string;
  iframeWidth: string;
  showCloseBtn: boolean = false;
  btnShown: boolean = true;
  isVertical: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<YoutubeDialogComponent>,
    public utilitiService: UtilityFunctionsService,
  ) {
    this.videoUrl = data.videoUrl;
    this.isVertical = data.isVertical || false;
    this.calculateIframeDimensions();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.calculateIframeDimensions();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.showCloseBtn = true;
    }, 500);
  }

  closeModal() {
    this.btnShown = false;
    this.dialogRef.close();
  }


  calculateIframeDimensions() {
    const dimensions = this.utilitiService.calculateIframeDimensions(this.isVertical);
    this.iframeWidth = dimensions.iframeWidth;
    this.iframeHeight = dimensions.iframeHeight;

    // Update dialog size on resize
    this.dialogRef.updateSize(this.iframeWidth, this.iframeHeight);
  }





}

